const authRequest = (state) => {
  state.status = 'loading'
}

const authSuccess = (state, token, user) => {
  state.status = 'success'
  state.token = token
  state.user = user
}

const authError = (state) => {
  state.status = 'error'
}

const logout = (state) => {
  state.status = ''
  state.token = ''
}

export default {
  authRequest,
  authSuccess,
  authError,
  logout
}
